import React, { useState, useEffect, useRef, forwardRef } from "react";
import axios from "axios";
import Multiselect from "multiselect-react-dropdown";

const RMultiSelect = forwardRef((props, ref) => {
  return (
    <div className="DropdownHeaderNIMP">
      {props.label}
      <Multiselect
        onRemove={(e, r) => props.onChange(e, r)}
        style={{ searchBox: { minHeight: "15vh" } }}
        onSearch={function noRefCheck() {}}
        displayValue="name"
        groupBy="Group"
        ref={ref}
        placeholder=""
        selectedValues={props.selected}
        avoidHighlightFirstOption="true"
        id="value"
        onSelect={(e, r) => props.onChange(e, r)}
        options={props.options}
        showCheckbox
      />
    </div>
  );
});

// Below are for the QBScience Multiselect drop downs

export function DDSystem(props) {
  const multiselectRef = useRef();
  const [SystemOptions, SetSystemOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetSystem = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=22&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          name: item.lovName,
          value: item.lovId,
          Group: "System's",
        }));
        SetSystemOptions(Options);
        const SOptions = Options.filter((item) =>
          props.Selected?.includes(item.value)
        );
        SetSelectedOptions(SOptions.length > 0 ? SOptions : [Options?.[0]]);
        const SelectedValues = SOptions.map((item) => item.value);
        props.StoreOptions(
          SelectedValues.length > 0 ? SelectedValues : [Options?.[0]?.value]
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    // if (props.Preselected === 0) {
    //     multiselectRef.current.resetSelectedValues();
    // }
    // SetSystemOptions();

    if (props.SubjectId && props.Preselected === 0) {
      SetSystemOptions();
      GetSystem();
    }
  }, [props.Preselected]);
  return (
    <>
      <RMultiSelect
        onChange={(e, r) => props.onChange(e, r)}
        selected={SystemOptions && SelectedOptions}
        ref={multiselectRef}
        options={SystemOptions}
        label="System :"
      />
    </>
  );
}

export function DDStream(props) {
  const multiselectRef = useRef();
  const [StreamOptions, SetStreamOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetStream = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/ScienceQuestionBankByLO/GetAllLODetails?ParentLovId=${props.Pid}&LovCategoryId=23`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        multiselectRef.current.resetSelectedValues();
        props.clear("Sytem");
        const Options = res.data.flatMap((element) =>
          element.Value.map((item) => ({
            name: item.LovDescription,
            value: item.LovId,
            Group: item.ParentLovName,
          }))
        );
        const SOptions = Options.filter((item) =>
          props.Preselected?.includes(item.value)
        );
        SetSelectedOptions(SOptions);
        SetStreamOptions(Options);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    props.clear("Sytem");
    if (props.Pid) {
      GetStream();
      // SetSelectedOptions();
    } else {
      multiselectRef.current.resetSelectedValues();
      SetStreamOptions();
      // props.clear("Sytem");
    }
  }, [props.Pid]);

  return (
    <RMultiSelect
      onChange={(e, r) => props.onChange(e, r)}
      selected={SelectedOptions}
      ref={multiselectRef}
      options={StreamOptions}
      label="Stream :"
    />
  );
}

export function DDSubSystem(props) {
  const multiselectRef = useRef();
  const [SubSystemOptions, SetSubSystemOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetSubSystem = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/ScienceQuestionBankByLO/GetAllLODetails?ParentLovId=${props.Pid}&LovCategoryId=24`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        multiselectRef.current.resetSelectedValues();
        props.clear("Stream");
        const Options = res.data.flatMap((element) =>
          element.Value.map((item) => ({
            name: item.LovDescription,
            value: item.LovId,
            Group: item.ParentLovName,
          }))
        );
        const SOptions = Options.filter((item) =>
          props.Preselected?.includes(item.value)
        );
        SetSelectedOptions(SOptions);
        SetSubSystemOptions(Options);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    props.clear("Stream");
    if (props.Pid) {
      GetSubSystem();
    } else {
      multiselectRef.current.resetSelectedValues();
      SetSubSystemOptions();
    }
  }, [props.Pid]);

  return (
    <RMultiSelect
      onChange={(e, r) => props.onChange(e, r)}
      selected={SelectedOptions}
      ref={multiselectRef}
      options={SubSystemOptions}
      label="Sub System :"
    />
  );
}

export function DDTopic(props) {
  const multiselectRef = useRef();
  const [STopicOptions, SetSTopicOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetSTopic = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/ScienceQuestionBankByLO/GetAllLODetails?ParentLovId=${props.Pid}&LovCategoryId=25`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        multiselectRef.current.resetSelectedValues();
        props.clear("SubSystem");
        const Options = res.data.flatMap((element) =>
          element.Value.map((item) => ({
            name: item.LovDescription,
            value: item.LovId,
            Group: item.ParentLovName,
          }))
        );
        const SOptions = Options.filter((item) =>
          props.Preselected?.includes(item.value)
        );
        SetSelectedOptions(SOptions);
        SetSTopicOptions(Options);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    props.clear("SubSystem");
    if (props.Pid) {
      GetSTopic();
    } else {
      multiselectRef.current.resetSelectedValues();
      SetSTopicOptions();
    }
  }, [props.Pid]);

  return (
    <RMultiSelect
      onChange={(e, r) => props.onChange(e, r)}
      selected={SelectedOptions}
      ref={multiselectRef}
      options={STopicOptions}
      label="Topic :"
    />
  );
}

export function DDSubTopic(props) {
  const multiselectRef = useRef();
  const [SubTopicOptions, SetSubTopicOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetSubTopic = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/ScienceQuestionBankByLO/GetAllLODetails?ParentLovId=${props.Pid}&LovCategoryId=26`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        multiselectRef.current.resetSelectedValues();
        props.clear("Topic");
        const Options = res.data.flatMap((element) =>
          element.Value.map((item) => ({
            name: item.LovDescription,
            value: item.LovId,
            Group: item.ParentLovName,
          }))
        );
        const SOptions = Options.filter((item) =>
          props.Preselected?.includes(item.value)
        );
        SetSelectedOptions(SOptions);
        SetSubTopicOptions(Options);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    props.clear("Topic");
    if (props.Pid) {
      GetSubTopic();
    } else {
      multiselectRef.current.resetSelectedValues();
      SetSubTopicOptions();
    }
  }, [props.Pid]);

  return (
    <RMultiSelect
      onChange={(e, r) => props.onChange(e, r)}
      selected={SelectedOptions}
      ref={multiselectRef}
      options={SubTopicOptions}
      label="Sub Topic :"
    />
  );
}

export function DDLearningOC(props) {
  const multiselectRef = useRef();
  const [LearningOCOptions, SetLearningOCOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetLOC = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/ScienceQuestionBankByLO/GetAllLODetails?ParentLovId=${props.Pid}&LovCategoryId=27`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        multiselectRef.current.resetSelectedValues();
        props.clear("SubTopic");
        const Options = res.data.flatMap((element) =>
          element.Value.map((item) => ({
            name: item.LovDescription,
            value: item.LovId,
            Group: item.ParentLovName,
          }))
        );
        const SOptions = Options.filter((item) =>
          props.Preselected?.includes(item.value)
        );
        SetSelectedOptions(SOptions);
        SetLearningOCOptions(Options);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    props.clear("SubTopic");
    if (props.Pid) {
      GetLOC();
    } else {
      multiselectRef.current.resetSelectedValues();
      SetLearningOCOptions();
    }
  }, [props.Pid]);
  return (
    <RMultiSelect
      onChange={(e, r) => props.onChange(e, r)}
      selected={SelectedOptions}
      ref={multiselectRef}
      options={LearningOCOptions}
      label="Learning Outcome :"
    />
  );
}

// export function DDSubLearningOC(props) {
//     const multiselectRef = useRef();
//     const [SubLearningOCOptions, SetSubLearningOCOptions] = useState();
//     const [SelectedOptions,SetSelectedOptions] = useState();
//     const GetSubLOC = async () => {
//         await axios.get(process.env.REACT_APP_API_BASE_URL + `/ScienceQuestionBankByLO/GetAllLODetails?ParentLovId=${props.Pid}&LovCategoryId=66`, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
//             .then((res) => {
//                 multiselectRef.current.resetSelectedValues();
//                 if(res.data?.[0].lovDescription){
//                     const Options = res.data?.map((item) => ({ name: item.lovDescription, value: item.lovId, Group: item.parentLovName }));
//                     const SOptions = Options.filter((item)=>props.Preselected?.includes(item.value) )
//                     SetSelectedOptions(SOptions);
//                     SetSubLearningOCOptions(Options);
//                 }
//             })
//             .catch((err) => { console.log(err); });
//     };
//     useEffect(() => {
//         if (props.Pid) { GetSubLOC(); } else {
//             multiselectRef.current.resetSelectedValues();
//             SetSubLearningOCOptions();
//         }
//     }, [props.Pid])
//     return (
//         <RMultiSelect onChange={(e, r) => props.onChange(e, r)} selected={SelectedOptions} ref={multiselectRef} options={SubLearningOCOptions} label=" Sub Learning Outcome :" />
//     )
// };
